export default __webpack_public_path__ + "static/media/forwardArrow.dd52a508.svg";